
import { createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import { CardMedia, Collapse, Grid } from '@material-ui/core';
import { useState } from 'react';

const useStyles = makeStyles((theme: Theme) => createStyles({
    banner: {
        width: '100vw',
        maxHeight: '30vh',
        objectFit: 'fill',
        marginBottom: '-5px'
    },
}));

const Banner = () => {
    const [isActive, setIsActive] = useState<boolean>(true);
    const classes = useStyles();

	return (
        <Collapse in={isActive}>
            <Grid item xs={12}>
                <CardMedia>
                    <video
                        onEnded={() => setIsActive(!isActive)}
                        className={classes.banner}
                        muted
                        autoPlay
                        src="/media/IntroPreflight.mp4" />
                </CardMedia>
            </Grid>
        </Collapse>
	)
}
export default Banner ;
